import { render } from "./TirarFoto.vue?vue&type=template&id=7e625112"
import script from "./TirarFoto.vue?vue&type=script&lang=js"
export * from "./TirarFoto.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__